//
import * as React from 'react';

import ListSubheader from '@mui/material/ListSubheader';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import LinkIcon from '@mui/icons-material/Link';

import { getLogger } from 'app-components/utils/core';

import FormikSelect from 'components/Formik/Select';
import { Field } from 'formik';

const log = getLogger('LinkActionSelector.js');

const LinkActionSelector = (props) => {
  const {
    name = 'action',
    accountsById,
    disabled,
    linkableAccountIdsSection1,
    linkableAccountIdsSection2,
    linkableAccountIdsSection3,
    onChange,
    isMint,
    ...other
  } = props;

  const addLinkToName = 'Add as New (no link)';
  // const linkToName = (id) => id !== '0' ? accountsById.get(id).name : addLinkToName;
  const linkToName = (id) => {
    if (id !== '0' && id !== null) {
      const account = accountsById.get(id);
      if (!account) {
        log.error('Expected account to be there', id, accountsById);
        return 'Error - Unknown';
      }
      return account.name;
    }
    return addLinkToName;
  };
  const renderValue = (id) => (
    <Stack direction='row'>
      <LinkIcon sx={{ alignSelf: 'center', color: 'iconMain', fontSize: '1.25rem', mr: 1 }} />
      <Typography variant='paragraphRegular' noWrap sx={{ lineHeight: '23px' }}>{`${
        id !== '0' ? 'Link to:' : ''
      } ${linkToName(id)}`}</Typography>
    </Stack>
  );

  const renderLinkToMenuItem = (id, divider = false) => (
    <MenuItem id='addItem' key={id} value={id} divider={divider}>
      <Typography variant='bodyRegular'>{linkToName(id)}</Typography>
    </MenuItem>
  );

  const renderLinkableAccounts = (linkableAccountIds, divider) =>
    linkableAccountIds.map((id, index) => renderLinkToMenuItem(id, divider && index === linkableAccountIds.size - 1));

  const renderLinkToAccounts = () => {
    if (isMint) {
      return renderLinkableAccounts(Object.keys(accountsById.toJS()));
    }
    let menuItems = [];
    if (linkableAccountIdsSection1?.size) {
      menuItems = menuItems.concat(
        renderLinkableAccounts(
          linkableAccountIdsSection1,
          (linkableAccountIdsSection2?.size ?? 0) > 0 || (linkableAccountIdsSection3?.size ?? 0) > 0,
        ),
      );
    }
    if (linkableAccountIdsSection2?.size) {
      menuItems = menuItems.concat(
        renderLinkableAccounts(linkableAccountIdsSection2, (linkableAccountIdsSection3?.size ?? 0) > 0),
      );
    }
    if (linkableAccountIdsSection3?.size) {
      menuItems = menuItems.concat(renderLinkableAccounts(linkableAccountIdsSection3, false));
    }
    return menuItems.length ? menuItems : null;
  };

  return (
    <Field
      component={FormikSelect}
      name={name}
      disabled={disabled}
      id={`account-${1}-link-to`}
      onFieldChange={onChange}
      SelectProps={{
        renderValue,
      }}
      size='small'
      variant='outlined'
      fullWidth
      {...other}
    >
      <ListSubheader>Link account to:</ListSubheader>
      {renderLinkToMenuItem('0', true)}
      {renderLinkToAccounts()}
    </Field>
  );
};

export default LinkActionSelector;
